import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import RefundStatuseRequest from "../../magData/Flight/RefundStatuseRequest";
import RefundByRefrenceResponse from "../../magData/Flight/RefundByRefrenceResponse";

function RefundStatus() {

    return (
        <>

            <Container fluid >
                <Row>
                    <Col sm={12} >
                        <p className="page-title">Refund By Refrence Method</p>
                    </Col>
                    <Col sm={12} >
                        <p>EndPoint : https://gdscpapi.parsgds.com/gateway/flight/refundStatus</p>
                    </Col>
                    <Col sm={12} >
                        <p> type : json (default)</p>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} >
                        <p>Body Parameters</p>
                    </Col>
                    <Col sm={12} >

                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td><Badge bg="warning" text="dark">
                                        Required
                                    </Badge></td>
                                </tr>
                                <tr>
                                    <td>refundType</td>
                                    <td>refundType</td>
                                    <td>integer</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(RefundStatuseRequest, null, 2)}
                        </pre>


                    </Col>
                </Row>

                {/* Response  */}
                <Row>
                    <Col sm={12} >
                        <p>Response Information</p>
                    </Col>
                    <Col sm={12} >

                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>refundEticketNumbers</td>
                                    <td>refundEticketNumbers</td>
                                    <td>Collection of string</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <Table bordered>
                                            <tbody>
                                                <tr>
                                                    <td>eTicketNumber</td>
                                                    <td>eTicketNumber</td>
                                                    <td>String</td>
                                                    <td>
                                                        <Badge bg="warning" text="dark">
                                                            None.
                                                        </Badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>eticketStatus</td>
                                                    <td>eticketStatus</td>
                                                    <td>integer</td>
                                                    <td>
                                                        <Badge bg="warning" text="dark">
                                                            None.
                                                        </Badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>isRefunded</td>
                                                    <td>isRefunded</td>
                                                    <td>String</td>
                                                    <td>
                                                        <Badge bg="warning" text="dark">
                                                            None.
                                                        </Badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>airlinePnr</td>
                                                    <td>airlinePnr</td>
                                                    <td>String</td>
                                                    <td>
                                                        <Badge bg="warning" text="dark">
                                                            None.
                                                        </Badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>penaltyAmount</td>
                                                    <td>penaltyAmount</td>
                                                    <td>integer</td>
                                                    <td>
                                                        <Badge bg="warning" text="dark">
                                                            None.
                                                        </Badge>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(RefundByRefrenceResponse, null, 2)}
                        </pre>


                    </Col>
                </Row>
            </Container>

        </>
    );
}

export default RefundStatus;